export const environment = {
  production: true,
  API_ROOT: 'https://api.dev.jobring.ai',
  SIGNUP_PILOT: true,
  STRIPE_CUSTOMER_ACCOUNT_LINK: '',
  OG_IMAGE_COUNT: 2,
  SOFT_AUTH_TOKEN: '01HA7RNKC6EWSJH8G0V2WFMC35',
};
